<template>
  <div class="row">
    <load mode="table" v-if="loading" />
    <div class="col-md-12" v-else>
      <div v-if="files.length > 0">
        <h4 class="font-weight-bold">{{ title ? title : "Anexo(s)" }}</h4>
        <form-input-group
          class="px-0"
          type="search"
          v-model="search"
          btn-class="btn input-group-text border-left-0 p-2 bg-white"
          icon-btn="mdi mdi-magnify mdi-18px"
          placeholder="Digite o nome ou parte para buscar um arquivo"
          @submit="filtrarResultados"
          @input="filtrarResultados"
        />
        <div v-if="search != '' && files.length == 0">
          <h4 class="text-secondary text-center">
            <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
            Nenhum Arquivo encontrado.
          </h4>
        </div>
        <table
          v-else
          class="table b-table b-table-stacked-lg table-bordered table-sm table-striped"
        >
          <thead>
            <tr>
              <th>Nome</th>
              <th colspan="2">Cadastrado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(anexo, index) in sortedRows" :key="anexo.id">
              <td>
                <img
                  :src="`/img/files/${formatFile(anexo.nome)}.svg`"
                  class="pr-2 float-left"
                  height="28"
                />
                {{ anexo.nome }}
              </td>
              <td>{{ anexo.created_at | formatDateHora() }}</td>
              <td>
                <div class="d-flex justify-content-end">
                  <b-button
                    :title="$t('Baixar')"
                    @click.prevent="downloadFile(anexo)"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="success"
                  >
                    <i class="mdi mdi-arrow-collapse-down"></i>
                  </b-button>
                  <b-button
                    :title="$t('Visualizar')"
                    @click.prevent="viewFile(anexo)"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                  >
                    <i class="fas fa-eye"></i>
                  </b-button>
                  <b-button
                    :title="$t('Excluir')"
                    @click.prevent="deleteFile(anexo, index)"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="danger"
                    v-if="user.id == anexo.user_id || anexo.user_id == null"
                  >
                    <i class="mdi mdi-close"></i>
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          :total="total"
          :current="currentPage"
          @update="setCurrentPage"
        />
        
      </div>
      <MovalView :anexo="anexoSelected" />
    </div>
  </div>
</template>
<script>
  import MovalView from "./includes/ViewArquivo";
  export default {
    components: { MovalView },
    props: ["anexos", "title"],
    data() {
      return {
        anexoSelected: "",
        files: [],
        filesTemp: [],
        loading: true,
        search: "",
        currentLengthResult: 0,
        pageSize: 10,
        total: 0,
        currentPage: 1,
        user: {},
        urlbase: `${window.location.protocol}//${window.location.host}/`,
      };
    },
    watch: {
      anexos(n, o) {
        this.init();
      },
    },
    mounted() {
      this.init();
    },
    computed: {
      sortedRows() {
        return this.files.filter((row, index) => {
          return this.filterDadosPorPagina(index);
        });
      },
    },
    methods: {
      getUserLogado() {
        axios.get(`api/account/getuser`).then((response) => {
          this.user = response.data;
        });
      },
      init() {
        this.getUserLogado();
        this.files = this.anexos;
        this.filesTemp = this.files;
        this.total = this.files ?  this.files.length : 0;
        this.loading = false;
      },
      formatFile(file) {
        return file.split(".").pop();
      },
      downloadFile(anexo) {
        let path = this.urlbase + anexo.caminho + "/" + anexo.nome;
        // window.open(path, "_blank");

        var anchor = document.createElement("a");
        anchor.href = path;
        anchor.download = path;
        document.body.appendChild(anchor);
        anchor.click();
      },
      viewFile(anexo) {
        this.anexoSelected = anexo;
        this.$bvModal.show("view-file");
      },
      deleteFile(anexo, index) {
        this.loading = true;
        axios
          .post(`api/dashboard/delete/arquivo`, { id: anexo.id })
          .then((response) => {
            this.files.splice(index, 1);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      filtrarResultados() {
        if (this.search != "") {
          this.files = this.files.filter((item) => {
            return item.nome.toLowerCase().includes(this.search.toLowerCase());
          });
        } else {
          this.files = this.filesTemp;
        }
        this.total = this.files.length;
      },
      setCurrentPage(current, pagesize) {
        this.currentPage = current;
        this.pageSize = pagesize;
      },
      filterDadosPorPagina(index) {
        if (this.pageSize > this.files.length) {
          let start = 0;
          let end = this.files.length;

          if (index >= start && index < end) return true;
        } else {
          let start = (this.currentPage - 1) * this.pageSize;
          let end = this.currentPage * this.pageSize;

          if (index >= start && index < end) return true;
        }
      },
    },
  };
</script>
